"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "affectedAction", {
    enumerable: true,
    get: function() {
        return affectedAction;
    }
});
const _logger = /*#__PURE__*/ _interop_require_default(require("@lage-run/logger"));
const _workspacetools = require("workspace-tools");
const _config = require("@lage-run/config");
const _getFilteredPackages = require("../../filter/getFilteredPackages.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function affectedAction(options) {
    const { dependencies, dependents, since, scope, ignore, outputFormat } = options;
    const cwd = process.cwd();
    const config = await (0, _config.getConfig)(cwd);
    const logger = (0, _logger.default)();
    const root = (0, _workspacetools.getWorkspaceRoot)(cwd);
    const packageInfos = await (0, _workspacetools.getPackageInfosAsync)(root);
    const packages = (0, _getFilteredPackages.getFilteredPackages)({
        root,
        logger,
        packageInfos,
        includeDependencies: dependencies,
        includeDependents: dependents,
        since,
        scope,
        repoWideChanges: config.repoWideChanges,
        sinceIgnoreGlobs: ignore
    });
    let output = "";
    switch(outputFormat){
        case "graph":
            output = renderGraph({
                packages,
                packageInfos
            });
            break;
        case "json":
            output = renderJson({
                packages,
                packageInfos
            });
            break;
        default:
            output = renderDefault({
                packages
            });
            break;
    }
    // eslint-disable-next-line no-console
    console.log(output);
}
function renderDefault(props) {
    const { packages } = props;
    return `
All Affected Packages
---------------------

${packages.join("\n")}
`;
}
function renderJson(props) {
    const graph = generatePackageGraph(props);
    return JSON.stringify(graph);
}
function renderGraph(props) {
    const graph = generatePackageGraph(props);
    const { packages } = graph;
    const adjacencies = [];
    for (const [pkg, info] of Object.entries(packages)){
        for (const dep of info.dependencies){
            adjacencies.push([
                pkg,
                dep
            ]);
        }
    }
    return `
digraph affected {
${adjacencies.map((entry)=>`  "${entry[0]}" -> "${entry[1]}"`).join("\n")}
}  
`;
}
function generatePackageGraph(props) {
    const { packages, packageInfos } = props;
    const packageGraph = packages.reduce((accum, pkg)=>{
        const dependencies = Object.keys(packageInfos[pkg].dependencies ?? {}).filter((dep)=>packages.includes(dep));
        const dependents = Object.keys(packageInfos[pkg].dependents ?? {}).filter((dep)=>packages.includes(dep));
        accum[pkg] = {
            dependencies,
            dependents
        };
        return accum;
    }, {});
    return {
        packages: packageGraph,
        count: packages.length
    };
}
